__turbopack_context__.v({
  "backLink": "breadcrumbs-module-scss-module__H0OA5a__backLink",
  "breadcumbsList": "breadcrumbs-module-scss-module__H0OA5a__breadcumbsList",
  "link": "breadcrumbs-module-scss-module__H0OA5a__link",
});
